// extracted by mini-css-extract-plugin
export default {"root":"RSNbKb","subtitle":"MyKHXl"};